// © Microsoft Corporation. All rights reserved.
/**
 * Create promise with timeout error
 */
export function promiseWithTimeout(promise, ms, timeoutError = new Error("Promise timed out")) {
    // create a promise that rejects in milliseconds
    const timeout = new Promise((_, reject) => {
        setTimeout(() => {
            reject(timeoutError);
        }, ms);
    });
    // returns a race between timeout and the passed promise
    return Promise.race([promise, timeout]);
}
//# sourceMappingURL=PromiseWithTimeout.js.map